import { REACT_APP_URL_HOST } from '../../config';
import './styles.scss';
const BetaBar = (props) => {
    if (props.route && (props.route.type === 'foodservice' || props.route.type === 'livs')) {
        
        const url = `${REACT_APP_URL_HOST.replace('-beta', '')}/scenario`;
      
        return (
            <div className="beta-bar">
                <div className="beta-bar__content">
                    <p>
                        Du avänder nu den nya versionen av säljdistrikt. För att byta tillbaka till den gamla, klicka <a href={url}>här</a>.
                    </p>
                </div>
            </div>
        );
    }

    return null;
};

export default BetaBar;